import { graphql } from '@/gql'

export const CreateJobMutation = graphql(/* GraphQL */ `
  mutation createJob($input: CreateJobInput!) {
    createJob(input: $input) {
      id
    }
  }
`)

export const UpdateJobMutation = graphql(/* GraphQL */ `
  mutation updateJob($input: UpdateJobInput!) {
    updateJob(input: $input) {
      ...JobFormData
    }
  }
`)

export const EndJobMutation = graphql(/* GraphQL */ `
  mutation endJob($input: EndJobInput!) {
    endJob(input: $input) {
      id
    }
  }
`)

export const SetInternalBudgetMutation = graphql(/* GraphQL */ `
  mutation setInternalBudgetOnJob($input: SetInternalBudgetOnJobInput!) {
    setInternalBudgetOnJob(input: $input) {
      id
    }
  }
`)

export const AttachJobToProjectMutation = graphql(/* GraphQL */ `
  mutation attachJobsToProject($input: AttachJobsToProjectInput!) {
    attachJobsToProject(input: $input) {
      id
    }
  }
`)

export const DetachJobFromProjectMutation = graphql(/* GraphQL */ `
  mutation detachJobFromProject($input: DetachJobFromProjectInput!) {
    detachJobFromProject(input: $input) {
      id
    }
  }
`)
